import { api } from './client';
import type { BotonCopiloto } from './copiloto.api';

/**
 * "Qué querés que cambiemos" — el buzón de pedidos.
 *
 * Conversar NO es de admin: quien encuentra los problemas es quien usa el
 * sistema todos los días, y ponerle un rol delante es la forma más rápida de no
 * enterarse de nada. Responder un pedido SÍ lo es: decirle a alguien que su
 * pedido se rechaza es una decisión, no una anotación.
 */

export type EstadoPedido = 'NUEVO' | 'EN_ANALISIS' | 'ACEPTADO' | 'RECHAZADO' | 'HECHO';

export interface PedidoDeCambio {
  id: string;
  codigo: string;
  nombre: string;
  titulo: string;
  pantalla: string | null;
  quePasa: string;
  queEsperaba: string;
  paraQue: string;
  urgencia: string;
  capturaKey: string | null;
  /** problema | cambio. Null en los pedidos anteriores al 13-sep. */
  tipo: string | null;
  /** Solo problema: cómo llega a que pase. */
  pasos: string | null;
  /** Solo problema: un caso concreto. */
  ejemplo: string | null;
  /** Solo problema: siempre | a_veces | una_vez. */
  frecuencia: string | null;
  estado: EstadoPedido;
  respuesta: string | null;
  createdAt: string;
}

export interface OpcionDeUrgencia {
  valor: string;
  label: string;
}

/** Hablar con el asistente para levantar un pedido. */
export const conversar = (texto: string) =>
  api.post<{ texto: string; botones?: BotonCopiloto[] }>('/api/pedidos/conversar', { texto });

export const listar = (estado?: EstadoPedido) =>
  api.get<{ pedidos: PedidoDeCambio[]; urgencias: OpcionDeUrgencia[] }>(
    `/api/pedidos${estado ? `?estado=${estado}` : ''}`,
  );

export const responder = (id: string, estado: EstadoPedido, respuesta?: string) =>
  api.post<{ ok: boolean }>(`/api/pedidos/${id}/responder`, { estado, respuesta });
